var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.order)?_c('section',{staticClass:"new_order"},[_c('edit-order-info',{attrs:{"order":_vm.order}}),_c('edit-order-product',{attrs:{"order":_vm.order}}),_c('div',{staticClass:"container has_table"},[_c('add-order-item',{attrs:{"order":_vm.order}})],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }